export default (() => {
  const CONSTANTS = {
    MODEL_TULUM: 11,
    MODEL_EXCLUDED_FROM_STICKY: 2,
    TRANSPARENT_MODELS: [2, 6, 8, 9, 12, 13],
    TWO_ROW_NAV_MODELS: [6, 8],
    FORCE_OFFSET_MAIN_IF_NOT_STICKY: [10, 11],
    MOBILE_BREAKPOINT: 1024,
    RESIZE_DEBOUNCE_MS: 150
  };

  const headerBlock = document.querySelector('.js-website-header');

  const fullScreenBookingEngineRendered = document.querySelector(
    'div[data-react-class="BookingEngineFullScreen/index"]',
  );

  if (!headerBlock) return;
  if (!fullScreenBookingEngineRendered) return;

  const config = {
    headerModel: Number(headerBlock.dataset.headerModel),
    headerId: Number(headerBlock.dataset.headerId),
  };

  function query(selector) {
    return document.querySelector(selector);
  }

  function getDesktopHeaderHeight() {
    const header = document.getElementById(`block_${config.headerId}`);
    if (!header) return 0;

    if (config.headerModel === 11) {
      const row = query(`#block_${config.headerId} .header_11_row`);
      return row ? Math.ceil(row.getBoundingClientRect().height) : Math.ceil(header.getBoundingClientRect().height);
    }

    if (CONSTANTS.TWO_ROW_NAV_MODELS.includes(config.headerModel)) {
      const container = query(`.site__navbar-model-${config.headerModel} .site__block--style.site__navbar`);
      let height = container ? Math.ceil(container.getBoundingClientRect().height) : Math.ceil(header.getBoundingClientRect().height);
      const logo = query(`.site__navbar-model-${config.headerModel} .site__navbar--logo`);
      const menu = query(`.site__navbar-model-${config.headerModel} .nav__menu`);
      const stacked = (logo ? logo.offsetHeight : 0) + (menu ? menu.offsetHeight : 0);
      return Math.max(height, stacked);
    }

    return Math.ceil(header.getBoundingClientRect().height);
  }

  function getMobileHeaderElement() {
    const isTulum = config.headerModel === CONSTANTS.MODEL_TULUM;
    const selector = isTulum ? `.top_navbar_${config.headerModel}_booking` : `#block_${config.headerId}_mob_nav #header`;
    return query(selector);
  }

  function getMobileHeaderHeight() {
    const element = getMobileHeaderElement();
    return element ? Math.ceil(element.getBoundingClientRect().height) : 0;
  }

  function updateHeaderHeight() {
    const isMobile = window.innerWidth < CONSTANTS.MOBILE_BREAKPOINT;
    const isTransparentModel = CONSTANTS.TRANSPARENT_MODELS.includes(config.headerModel);
    const hasCustomCoverImage = !!query('.booking_engine__background-wrap .j-background-image');
    const main = document.getElementById("main-content");
    if (!main) return;

    if (hasCustomCoverImage) {
      if ([2, 7, 12].includes(config.headerModel)) {
        return;
      }

      if (isMobile) {
        const wrapper = query('.booking_engine__background-model2');
        if (wrapper) {
          const height = getMobileHeaderHeight() || 60;
          wrapper.style.marginTop = height + "px";
        }
      }
      return;
    }

    const wrapper = query(".booking_engine__background, .booking_engine__background-white");
    if (isTransparentModel && wrapper) {
      const activeHeight = isMobile ? (getMobileHeaderHeight() || 60) : (getDesktopHeaderHeight() || 74);
      wrapper.style.marginTop = Math.max(activeHeight, 0) + "px";
      wrapper.style.backgroundColor = "transparent";
      return;
    }

    if (config.headerModel === 12 && bookingEngineWrapper) {
      const activeHeight = isMobile ? (getMobileHeaderHeight() || 60) : (getDesktopHeaderHeight() || 74);
      bookingEngineWrapper.style.marginTop = Math.max(activeHeight, 0) + "px";
      bookingEngineWrapper.style.backgroundColor = "transparent";
      return;
    }

    const header = document.getElementById(`block_${config.headerId}`);
    let height = 0;
    const stickyEnabled = header && header.classList.contains("sticky-header");
    const isExcludedModel = config.headerModel === CONSTANTS.MODEL_EXCLUDED_FROM_STICKY;

    if (isMobile) {
      const mobileHeader = getMobileHeaderElement();
      height = mobileHeader ? mobileHeader.offsetHeight : 0;
    } else {
      if (stickyEnabled && !isExcludedModel) {
        height = header ? header.offsetHeight : 0;
      } else if (CONSTANTS.FORCE_OFFSET_MAIN_IF_NOT_STICKY.includes(config.headerModel)) {
        height = getDesktopHeaderHeight() || 0;
      }
    }

    main.style.setProperty("--header-height", (height || 0) + "px");
    main.classList.add("has-header-height");
  }

  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeaderHeight, CONSTANTS.RESIZE_DEBOUNCE_MS);
  }

  updateHeaderHeight();
  window.addEventListener("resize", handleResize);
  window.addEventListener("load", updateHeaderHeight);
  new MutationObserver(updateHeaderHeight).observe(document.body, { childList: true, subtree: true });
})();